module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy S9 Burgundy Red.2cd9027b.png";